module.exports = __webpack_public_path__ + "static/media/gift.f249ff8b.svg";